export default {
  monthlyCost: {
    id: 'product_page_telco_calculator_modal_calculator_monthly_cost',
    defaultMessage: 'Monthly cost',
  },
  contractLength: {
    id: 'product_page_telco_calculator_modal_calculator_length_name',
    defaultMessage: 'Contract length',
  },
  contractDurationByMonth: {
    id: 'product_page_telco_calculator_modal_calculator_length',
    defaultMessage: '{duration} months',
  },
  contractDuration: {
    id: 'product_page_telco_calculator_modal_calculator_length_duration',
    defaultMessage: '36',
  },
  contractBMMonthlyCost: {
    id: 'product_page_telco_calculator_modal_calculator_bm_monthly_cost',
    defaultMessage: '25',
  },
}
